export const FETCH = "_FETCH";
export const DONE = "_DONE";
export const FAIL = "_FAIL";
export const RESET = "_RESET";
export const HANDLE = "_HANDLE";
export const ADD = "_ADD";
export const ONE = "_ONE";
export const DELETE = "_DELETE";
export const EDIT = "_EDIT";
export const SET = "_SET";
export const GET = "_GET";
export const COMMON = "COMMON";
export const LESSON = "LESSON";
export const PLAN = "PLAN";
export const COPY = "COPY";
export const LESSON_ID = "LESSON_ID";
export const LESSON_BY_ASSIGN = "LESSON_BY_ASSIGN";
export const PERIOD = "PERIOD";
export const MODAL = "MODAL";
export const POST = "POST";
export const VIEW = "VIEW";
export const LIST = "LIST";
export const ALL = "ALL";
export const SELECT = "SELECT";
export const DATA = "DATA";
export const AUTH = "AUTH";
export const JOURNAL = "JOURNAL";
export const TABLE = "TABLE";
export const LOG = "LOG";
export const EXPORT = "EXPORT";
export const FILTER = "FILTER";
export const CTP = "CTP";
export const MENU = "MENU";
export const YEAR = "YEAR";
export const TASK = "TASK";
export const TEST = "TEST";
export const FINISH = "FINISH";
export const RESULT = "RESULT";
export const ANSWER = "ANSWER";
export const PROCTORING = "PROCTORING";
export const MATERIAL = "MATERIAL";
export const FORM = "FORM";
export const EXTRA = "EXTRA";
export const MARK = "MARK";
export const ACCOUNTING = "ACCOUNTING";
export const INDIVIDUAL = "INDIVIDUAL";
export const MODALDATA = "MODALDATA";
export const SUBJECTS = "plans.ts/SUBJECTS";
export const PERSON = "auth/PERSON";
export const LOGOUT = "auth/LOGOUT";

export const BEGIN = 'BEGIN';
export const END = 'END';
export const CURRENT = 'CURRENT';
export const ITEM = 'ITEM';
export const INNER = 'INNER';
export const CONTENT = 'CONTENT';
export const OUTER = 'OUTER';
export const COLUMN = "COLUMN";
export const PRINT = "PRINT";
export const STUDY = "STUDY";
export const MEDICAL = "MEDICAL";
export const MODULE = "MODULE";
export const REMARK = "REMARK";
export const TOTAL_UVR = "TOTAL_UVR";

//auth
export const PROFILE = "PROFILE";
export const NOTIFICATION = "NOTIFICATION";
export const VISIT = "VISIT";

export const PROFILE_ROLE = "PROFILE_ROLE"
export const PROFILE_ROLE_NAME = "PROFILE_ROLE_NAME"

export const JOURNAL_DATA = "journal/JOURNAL_DATA";
//meals
export const MEALS_DATA = "journal/MEALS_DATA";
export const MEALS_CTP_LIST = "journal/MEALS_CTP_LIST";
export const SAVE_MEALS_MARKS = "journal/SAVE_MARKS";

// schedule
export const SCHEDULE = "SCHEDULE";


export const HELPER = "HELPER";
export const RUPS = "RUPS";
export const RUP = "RUP";
export const DUPLICATE = "DUPLICATE";
export const REVERT = "REVERT";
export const RECOMMENDED = "RECOMMENDED";
export const QUALIFICATIONS = "QUALIFICATIONS";
export const SPECIALITIES = "SPECIALITIES";
export const DISCIPLINES = "DISCIPLINES";
export const ID = "ID";
export const OPTIONS = "OPTIONS";
export const SEMESTER = "SEMESTER";
export const SETTINGS = "SETTINGS";
export const TYPES = "TYPES";
export const INFO = "INFO";
export const STRUCTURE = "STRUCTURE";
export const RESTORE = "RESTORE";
export const GROUPS = "GROUPS";
export const APPEALS = "APPEALS";
export const BY = "BY";
export const PERFORMANCE = "PERFORMANCE";
export const SDOT = "SDOT";
export const STUDENT = "STUDENT";
export const LIBRARY = "LIBRARY";
export const IMPORT = "IMPORT";
export const PARAMS = "PARAMS";
export const EXAM = "EXAM";
export const LEAVE = "LEAVE";
export const TABS = "TABS";

//entrant
export const ENTRANT_REGISTER = "ENTRANT_REGISTER"
export const ENTRANT_VERIFICATION_CODE = "ENTRANT_VERIFICATION_CODE"

  //entrant_admission
  export const ADMISSION_EDUCATION = "admission/EDUCATION";
  export const ADMISSION_COLLEGES = "admission/COLLEGES";
  export const ADMISSION_FOUR_SPECIALITIES_ARRAY = "admission/FOUR_SPECIALITIES_ARRAY";
  export const ADMISSION_STEPS_DATA = "admission/STEPS_DATA";
  export const ADMISSION_LANGUAGES = "admission/ADMISSION_LANGUAGES";
  export const ADMISSION_FOUR_SPECIALITIES_DATA = "admission/FOUR_SPECIALITIES_DATA";
  export const ADMISSION_PROVINCES = "admission/PROVINCES";
  export const ADMISSION_DOCUMENT = "admission/ADMISSION_DOCUMENT";
  export const ADMISSION_IIN = "admission/IIN";
  export const ADMISSION_EMAIL = "admission/EMAIL";
  export const ADMISSION_INFO = "admission/INFO";
  export const ADMISSION_MARKS = "admission/MARKS";
  export const ADMISSION_NEW_MARK = 'admission/NEW_MARK';
  export const ADMISSION_PROFILE = "admission/PROFILE";
  export const ADMISSION_LESSON = "admission/LESSON";
  export const ADMISSION_EXAM = "admission/EXAM";
  export const ADMISSION_ORDER = "admission/ORDER";
  export const ADMISSION_GROUPS = "admission/GROUPS";
  export const ADMISSION_STATUS = "admission/STATUS";
  export const ADMISSION_STUDENT_LIST = "admission/STUDENT_LIST";
  export const ADMISSION_EXECUTOR_EGOV_APPLICATION = "admission/EXECUTOR_EGOV_APPLICATION";
  export const ADMISSION_TOTAL = "admission/TOTAL";
  export const ADMISSION_REASON = "admission/REASON";
  export const ADMISSION_COLLEGE_AND_EXECUTOR = "admission/COLLEGE_AND_EXECUTOR";
  export const ADMISSION_ENTRANT_APPLICATIONS = "admission/ENTRANT_APPLICATIONS";
  export const ADMISSION_LOG = "admission/LOG";
  //общий конкурс приёмка
  export const ADMISSION_GENERAL_CONTEST = 'admission/GENERAL_CONTEST'
  export const ADMISSION_GENERAL_CONTEST_WITH_QUOTES = 'admission/GENERAL_CONTEST_WITH_QUOTES'
  export const ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST = 'admission/GENERAL_CONTEST_SPECIALITIES_LIST'
  export const ADMISSION_GENERAL_CONTEST_CHANGE_STATUS = 'admission/GENERAL_CONTEST_CHANGE_STATUS'
  export const ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER = 'admission/GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER'
  export const ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE = 'admission/GENERAL_CONTEST_TRANSFER_TO_COLLEGE'

  //entrant-info
  export const ADMISSION_ENTRANT_INFO = 'admission/ENTRANT_INFO'

  //sign xml parent/entrant
  export const ADMISSION_EDUCATION_ORDER_XML = 'admission/EDUCATION_ORDER_XML'


  // PSYCHOLOGIST
  export const PSYCHOLOGIST = "PSYCHOLOGIST"
  export const WORK = "WORK"
  export const TEACHERS = "TEACHERS"
  